// Archivo para modal de confirmación de eliminaciones
import React from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

// Formularios por módulo
import ActivityForm from '../forms/ActivityForm'
import ConsumerForm from '../forms/ConsumerForm'

const GenericModal = ({
  open,
  onClose,
  onConfirm,
  title,
  confirmText,
  danger,
  module,
}) => {
  const { t } = useTranslation()
  const [formData, setFormData] = React.useState({})

  const renderForm = () => {
    switch (module) {
      case 'Actividad':
        return <ActivityForm onChange={setFormData} />
      case 'Consumidor':
        return <ConsumerForm onChange={setFormData} />
      default:
        return <p>Formulario no disponible</p>
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{renderForm()}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {t('buttons.cancel')}
        </Button>
        <Button
          onClick={() => onConfirm(formData)}
          color={danger ? 'error' : 'primary'}
          variant="contained"
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

GenericModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  confirmText: PropTypes.string.isRequired,
  danger: PropTypes.bool,
  module: PropTypes.string.isRequired,
}

export default GenericModal
